import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { serverApi } from '../../api';
import logo from '../../assets/logo-PIT-1-768x288-fondo.png';
import { useHideMenu } from '../../hooks/useHideMenu';
import { NuevaEmpresaModal } from './NuevaEmpresaModal';
import { EditarEmpresaModal } from './EditarEmpresaModal';

export const VendedorPanel = () => {
    useHideMenu(true);
    const navigate = useNavigate();

    const [empresas, setEmpresas] = useState([]);
    const [precios, setPrecios] = useState({ precioBaseSede: 500000, precioPorSedeAdicional: 100000, moneda: 'COP' });
    const [showEmpresaModal, setShowEmpresaModal] = useState(false);
    const [showEditModal, setShowEditModal] = useState(false);
    const [empresaSeleccionada, setEmpresaSeleccionada] = useState(null);
    const [loading, setLoading] = useState(false);

    const userRaw = localStorage.getItem('vendedorUser');
    const vendedorUser = userRaw ? JSON.parse(userRaw) : { codigoVendedor: '', nombreVendedor: 'Vendedor' };

    const cargarMisEmpresas = useCallback(async () => {
        if (!vendedorUser.codigoVendedor) return;
        try {
            setLoading(true);
            const [respEmp, respPrec] = await Promise.all([
                serverApi.get(`/superadmin/entidades?codigoVendedor=${vendedorUser.codigoVendedor}`),
                serverApi.get('/superadmin/precio'),
            ]);
            if (respEmp.data.ok) setEmpresas(respEmp.data.entidades || []);
            if (respPrec.data.ok) setPrecios(respPrec.data.precios || {});
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [vendedorUser.codigoVendedor]);

    useEffect(() => {
        cargarMisEmpresas();
    }, [cargarMisEmpresas]);

    const handleEditarEmpresa = (empresa) => {
        setEmpresaSeleccionada(empresa);
        setShowEditModal(true);
    };

    const handleLogout = () => {
        localStorage.removeItem('vendedorToken');
        localStorage.removeItem('vendedorUser');
        navigate('/superadmin');
    };

    return (
        <div style={{
            minHeight: '100vh',
            background: '#f4f7f6',
            fontFamily: "'Inter', Arial, sans-serif",
            paddingBottom: 40,
        }}>
            {/* Header */}
            <div style={{
                background: 'linear-gradient(135deg, #0d7367 0%, #0c695e 100%)',
                color: 'white', padding: '16px 32px',
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                boxShadow: '0 4px 20px rgba(13,115,103,0.25)',
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <img src={logo} alt="logo" style={{ height: 58, marginBottom: 12, borderRadius: 10 }} />
                    <div>
                        <h3 style={{ margin: 0, fontWeight: 900, fontSize: 18 }}>Portal Comercial Vendedor</h3>
                        <span style={{ fontSize: 12, opacity: 0.85 }}>Código: <b>{vendedorUser.codigoVendedor}</b></span>
                    </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <div style={{ background: 'rgba(255,255,255,0.15)', padding: '6px 14px', borderRadius: 20, fontSize: 13, fontWeight: 700 }}>
                        💼 {vendedorUser.nombreVendedor}
                    </div>
                    <button onClick={handleLogout} style={{
                        background: '#ef4444', border: 'none', color: 'white',
                        padding: '8px 16px', borderRadius: 10, fontWeight: 700, cursor: 'pointer', fontSize: 13,
                    }}>
                        Cerrar Sesión ✕
                    </button>
                </div>
            </div>

            {/* Content */}
            <div style={{ maxWidth: 1100, margin: '28px auto 0', padding: '0 20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                    <div>
                        <h3 style={{ margin: 0, fontWeight: 800, color: '#0f172a' }}>
                            Mis Empresas Clientes ({empresas.length})
                        </h3>
                        <p style={{ margin: '4px 0 0', color: '#64748b', fontSize: 13 }}>
                            Empresas creadas bajo su código comercial
                        </p>
                    </div>
                    <button onClick={() => setShowEmpresaModal(true)} style={{
                        padding: '12px 24px', borderRadius: 12, border: 'none',
                        background: 'linear-gradient(135deg, #0d7367 0%, #14b8a6 100%)',
                        color: 'white', fontWeight: 800, fontSize: 14, cursor: 'pointer',
                        boxShadow: '0 4px 14px rgba(13,115,103,0.35)',
                    }}>
                        ➕ Crear Nueva Empresa Cliente
                    </button>
                </div>

                {/* Tabla de mis empresas */}
                <div style={{ background: 'white', borderRadius: 16, overflow: 'hidden', boxShadow: '0 4px 20px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0' }}>
                    {loading ? (
                        <div style={{ padding: 40, textAlign: 'center', color: '#64748b' }}>
                            <i className="fa-solid fa-spinner fa-spin" style={{ fontSize: 24, marginBottom: 8 }}></i>
                            <p style={{ margin: 0 }}>Cargando empresas...</p>
                        </div>
                    ) : (
                        <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left' }}>
                            <thead>
                                <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0', color: '#475569', fontSize: 12, textTransform: 'uppercase', letterSpacing: 0.8 }}>
                                    <th style={{ padding: '14px 18px' }}>Código Entidad</th>
                                    <th style={{ padding: '14px 18px' }}>Nombre Empresa</th>
                                    <th style={{ padding: '14px 18px' }}>Contacto</th>
                                    <th style={{ padding: '14px 18px', textAlign: 'center' }}>Sedes</th>
                                    <th style={{ padding: '14px 18px' }}>Fecha Registro</th>
                                    <th style={{ padding: '14px 18px', textAlign: 'center' }}>Estado</th>
                                    <th style={{ padding: '14px 18px', textAlign: 'center' }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {empresas.length === 0 ? (
                                    <tr>
                                        <td colSpan="7" style={{ textAlign: 'center', padding: 40, color: '#94a3b8' }}>
                                            Aún no ha registrado ninguna empresa cliente. Haga clic en <b>"Crear Nueva Empresa Cliente"</b> para comenzar.
                                        </td>
                                    </tr>
                                ) : (
                                    empresas.map(e => (
                                        <tr key={e.codigoEntidad} style={{ borderBottom: '1px solid #f1f5f9', fontSize: 14 }}>
                                            <td style={{ padding: '14px 18px', fontWeight: 800, color: '#0d7367' }}>
                                                {e.codigoEntidad}
                                            </td>
                                            <td style={{ padding: '14px 18px', fontWeight: 700, color: '#0f172a' }}>
                                                {e.nombreEntidad}
                                                {e.ciudad && <span style={{ display: 'block', fontSize: 12, color: '#64748b', fontWeight: 400 }}>{e.ciudad}</span>}
                                            </td>
                                            <td style={{ padding: '14px 18px', color: '#475569', fontSize: 13 }}>
                                                {e.emailContacto && <div>📧 {e.emailContacto}</div>}
                                                {e.telefonoContacto && <div>📞 {e.telefonoContacto}</div>}
                                            </td>
                                            <td style={{ padding: '14px 18px', textAlign: 'center' }}>
                                                <span style={{ background: '#ecfdf5', color: '#047857', fontWeight: 800, padding: '4px 12px', borderRadius: 12, fontSize: 13 }}>
                                                    {e.sedesRegistradas || 1} / {e.maxSedes} sedes
                                                </span>
                                            </td>
                                            <td style={{ padding: '14px 18px', color: '#64748b', fontSize: 13 }}>
                                                {e.fechaCreacion ? String(e.fechaCreacion).substring(0, 10) : '—'}
                                            </td>
                                            <td style={{ padding: '14px 18px', textAlign: 'center' }}>
                                                <span style={{
                                                    background: e.indActivo ? '#dcfce7' : '#fee2e2',
                                                    color: e.indActivo ? '#15803d' : '#b91c1c',
                                                    fontWeight: 800, fontSize: 12, padding: '4px 10px', borderRadius: 20,
                                                }}>
                                                    {e.indActivo ? 'ACTIVA' : 'INACTIVA'}
                                                </span>
                                            </td>
                                            <td style={{ padding: '14px 18px', textAlign: 'center' }}>
                                                <button
                                                    onClick={() => handleEditarEmpresa(e)}
                                                    title="Editar empresa"
                                                    style={{
                                                        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                                                        border: 'none', color: 'white',
                                                        padding: '7px 16px', borderRadius: 10,
                                                        fontWeight: 700, fontSize: 13, cursor: 'pointer',
                                                        boxShadow: '0 2px 8px rgba(30,64,175,0.25)',
                                                        display: 'inline-flex', alignItems: 'center', gap: 6,
                                                        transition: 'opacity 0.15s',
                                                    }}
                                                    onMouseEnter={ev => ev.currentTarget.style.opacity = '0.85'}
                                                    onMouseLeave={ev => ev.currentTarget.style.opacity = '1'}
                                                >
                                                    ✏️ Editar
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>

            {/* Modal Crear Empresa */}
            <NuevaEmpresaModal
                show={showEmpresaModal}
                onClose={() => setShowEmpresaModal(false)}
                onSuccess={cargarMisEmpresas}
                vendedores={[]}
                preselectedVendedor={vendedorUser.codigoVendedor}
                preciosConfig={precios}
            />

            {/* Modal Editar Empresa */}
            <EditarEmpresaModal
                show={showEditModal}
                onClose={() => { setShowEditModal(false); setEmpresaSeleccionada(null); }}
                onSuccess={() => { cargarMisEmpresas(); setShowEditModal(false); setEmpresaSeleccionada(null); }}
                empresa={empresaSeleccionada}
                isSuperAdmin={true}
            />
        </div>
    );
};
